import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { WelcomeName } from "./WelcomeName";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import { Link as RouterLink } from "react-router-dom";
import { AuthenticatedTemplate, useIsAuthenticated } from "@azure/msal-react";
import Grid from '@mui/material/Grid';
const pages = new Map();
pages.set('/CaseDevelopment', 'Case <br /> Development');
pages.set('/CaseDate', 'Case <br /> Date');
pages.set('/CaseDocuments', 'Case <br /> Documents');
pages.set('/RequestForApproval', 'Request For <br /> Approval');
pages.set('/PersonnelChange', 'Personnel <br /> Change');
pages.set('/ImportInvoice', 'Submit <br /> Invoice');
pages.set('/PersonnelRate', 'Personnel <br /> Rates');
pages.set('/RequestForRemoval', 'Personnel <br /> Removal');
const NavBar = () => {



    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const isAuthenticated = useIsAuthenticated();
    return (
        <AppBar position="static">
            <Box sx={{ flexGrow: 1, paddingLeft: 0, paddingRight:0 }} >
                <Toolbar disableGutters>
                    <Grid container size={12} sx={{ fontSize: '0.79em', textDecoration: 'none', bgcolor: '#8B0E04', color: '#f8f9fa' }} className="test3">
                        <Grid xs={2} >

                        </Grid>
                        <Grid xs={8} >
                            <Typography sx={{ paddingTop: '0.3rem', paddingBottom: '0.3rem', color: '#ffffff', fontSize: '0.8888em', fontWeight: 'bold' }}>
                                Official website of the City of San Antonio
                            </Typography>
                        </Grid>
                        <Grid xs={2} >

                        </Grid>
                        <Grid item sm={2} justifyContent="flex-start" sx={{ bgcolor: '#EEE' }}>
                            {/*<Box
                                variant="div"
                                component="img"
                                sx={{height: 48, display:'inline-block'}}
                                alt="City of San Antonio Quatre foil LOGO in white"
                                src={require('./assets/cosa_quatrefoil_TEXAS_WHITE.png')}
                            ></Box>  
                            <Box>
                                
                            <Typography component="div" variant="h6" style={{display: 'inline-block', paddingLeft: '10px', paddingTop:'9px'}}>Official website of the City of San Antonio</Typography>
                            </Box>*/}
                        </Grid>
                        <Grid item sm={5} justifyContent="left" textAlign={'left'} sx={{ display: "flex", bgcolor: '#EEE', color: '#333333' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Box component="img" sx={{ height: 80 }} alt="City of San Antonio Quatre foil LOGO in white" src={require('./assets/cosa_quatrefoil_TEXAS.png')} />
                                <Typography variant="h6" style={{ display: 'inline-block', paddingLeft: '10px', paddingTop: '9px', color: '#333333' }}>Outside Counsel Invoice Tool</Typography>

                            </Box>

                            {/*<Box>
                                
                            <Typography component="div" variant="h6" style={{display: 'inline-block', paddingLeft: '10px', paddingTop:'9px'}}>Official website of the City of San Antonio</Typography>
                            </Box>*/}
                        </Grid>
                        <Grid item sm={5} justifyContent="flex-end" textAlign={'right'} sx={{ display: "flex", paddingTop: '3px', bgcolor: '#EEE', color: '#333333', paddingRight: '24px'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography component="div" textAlign={'right'} sx={{ display: "flex", paddingTop: '3px' }}>
                                    {isAuthenticated ? <WelcomeName /> : null}
                                </Typography>
                                <Typography component="div" textAlign={'right'}>
                                    {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Toolbar>
            </Box>
            <AuthenticatedTemplate>
                <Toolbar sx={{ bgcolor: "#333333", color: "#EEEEEE" }}>
                    <Container sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button component={RouterLink} to="/CaseDevelopment" color="inherit">Case <br /> Development</Button>
                        <Button component={RouterLink} to="/CaseDate" color="inherit">Case <br /> Date</Button>
                        <Button component={RouterLink} to="/CaseDocuments" color="inherit">Case <br /> Documents</Button>
                        <Button component={RouterLink} to="/RequestForApproval" color="inherit">Request For <br /> Approval</Button>
                        <Button component={RouterLink} to="/PersonnelChange" color="inherit">Personnel <br /> Change</Button>
                        <Button component={RouterLink} to="/ImportInvoice" color="inherit">Submit <br /> Invoice</Button>
                        <Button component={RouterLink} to="/PersonnelRate" color="inherit">Personnel <br /> Rates</Button>
                        <Button component={RouterLink} to="/RequestForRemoval" color="inherit">Personnel <br /> Removal</Button>
                    </Container>
                </Toolbar>
            </AuthenticatedTemplate>
        </AppBar>
    );
};

export default NavBar;